<!--心理健康政策详情-->
<template>
    <div class="app-container">
        <div class="x-nav">
            <el-breadcrumb :separator="'＞'">
                <el-breadcrumb-item @click="backList"><a>心理健康-政策</a></el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="never" style="height: calc(100vh - 140px);overflow: auto;">
            <div class="dj-container">
                <div class="dj-content" v-html="form.content">
                </div>
            </div>
        </el-card>

    </div>
</template>

<script>
import {infoZhengc} from "@/api/admin/zhengc"

export default {
    name: "mentalHealthDetail",
    components: {
    },
    data() {
        return {
            // 遮罩层
            loading: true,
            zhengcId:'',
            // 表单参数
            form: {
                title: '',
                content:'',
                appContent:'',
                category:'',
                releaseTime:'',
            },
        };
    },
    created() {

    },
    mounted() {
        if (this.$route.query.zhengcId) {
            this.zhengcId = this.$route.query.zhengcId
            this.queryZhengcInfo()
        }
    },
    computed: {},
    methods: {
        queryZhengcInfo(){
            infoZhengc({ zhengcId: this.zhengcId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        backList(){
            this.$router.push({
                path: "/mentalHealth",
            });
        },
    }
}
</script>

<style scoped>
.dj-container{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.dj-content{
    width: 96%;
    margin: auto;
    overflow-x: hidden;
}
</style>
